import createIcon from '../../createIcon';

/**
 * @component @name StopScreenShare
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuMjIgMTcuNzlMMjMuMjIgMTkuNzlIMjRWMTcuNzlIMjEuMjJaTTIxLjk5IDE1Ljc5TDIyIDUuNzlDMjIgNC42OCAyMS4xIDMuNzkgMjAgMy43OUg3LjIyTDEyLjQ1IDkuMDJDMTIuNjMgOC45OCAxMi44MSA4Ljk1IDEzIDguOTJWNi43OUwxNyAxMC41MkwxNS40MiAxMS45OUwyMC45NiAxNy41M0MyMS41NyAxNy4yIDIxLjk5IDE2LjU0IDIxLjk5IDE1Ljc5Wk0yLjM5IDEuNUwxLjExIDIuNzdMMi42NSA0LjMxQzIuMjUgNC42NyAyIDUuMiAyIDUuNzlWMTUuNzlDMiAxNi44OSAyLjg5IDE3Ljc5IDQgMTcuNzlIMFYxOS43OUgxOC4xM0wyMC44NCAyMi41TDIyLjExIDIxLjIzTDIuMzkgMS41Wk03IDE0Ljc5QzcuMzEgMTMuMzEgNy45MiAxMS44NCA5LjA3IDEwLjczTDEwLjY2IDEyLjMyQzkuMTIgMTIuNyA3Ljk2IDEzLjUgNyAxNC43OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StopScreenShare = createIcon('StopScreenShare', [
  [
    'path',
    {
      d: 'M21.22 17.79L23.22 19.79H24V17.79H21.22ZM21.99 15.79L22 5.79C22 4.68 21.1 3.79 20 3.79H7.22L12.45 9.02C12.63 8.98 12.81 8.95 13 8.92V6.79L17 10.52L15.42 11.99L20.96 17.53C21.57 17.2 21.99 16.54 21.99 15.79ZM2.39 1.5L1.11 2.77L2.65 4.31C2.25 4.67 2 5.2 2 5.79V15.79C2 16.89 2.89 17.79 4 17.79H0V19.79H18.13L20.84 22.5L22.11 21.23L2.39 1.5ZM7 14.79C7.31 13.31 7.92 11.84 9.07 10.73L10.66 12.32C9.12 12.7 7.96 13.5 7 14.79Z',
      key: 'uzvsov',
    },
  ],
]);

export default StopScreenShare;
